import { FC } from "react";
import { TPageUrl } from "../../../routing/accessMap";
import { Link as RouterLink } from "react-router-dom";
import Link from "@mui/material/Link";

const LinkRemindForm: FC<{ url?: TPageUrl }> = ({ url = '/oauth/remind'}) => (  
  <Link component={RouterLink} to={url} variant="body2">
    Forgot password?
  </Link>  
);

export default LinkRemindForm;
